import React from 'react';

const ContentLibraryLabel = () => (
  <>{t('settings.tab.roles.edit.image_and_content_library_label')}</>
);

export default ContentLibraryLabel;
